import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private apiUrl = `${environment.baseUrl}/projects`; // Adjust your endpoint
  constructor(private http: HttpClient, private commonAPI: CommonApiService) {

   }

  addProject(projectData: any) {
    const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let body = {
          "criteria": {
             "ProjectShortCode" : projectData.ProjectShortCode,
             "ProjectName" : projectData.ProjectName,
             "CustomerShortCode" : projectData. CustomerShortCode,
              tenant : null
                }
        };

    return this.commonAPI.postApiCall(`${this.apiUrl}/AddProject`, body);
    // return this.http.post(`${this.apiUrl}/AddProject`, projectData);
  }


  getProjects(filter: any) {
    // debugger;
    console.log(`${this.apiUrl}/projects`);
    console.log(filter);
const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let body = {
          "criteria": {
             "filterarr" : filter,
                           tenant : null
                }
        };


    return this.commonAPI.postApiCall(`${this.apiUrl}/projects`, body);
    // return this.http.post(`${this.apiUrl}/projects`, filter);
  }

  getActiveProjects(filter: any, projectLifecycleFilter?: string | null) {
    const criteria: Record<string, unknown> = {
      filterarr: filter,
      tenant: null,
    };
    if (projectLifecycleFilter) {
      criteria['projectLifecycleFilter'] = projectLifecycleFilter;
    }
    const body = { criteria };

    return this.commonAPI.postApiCall(`${this.apiUrl}/ActiveProjects`, body);
    
    // return this.http.post(`${this.apiUrl}/ActiveProjects`, filter);
  }
  getCustomers() {
    return this.commonAPI.getApiCall(`${this.apiUrl}/GetCustomersList`);
  }

  addCustomer(customerData: { CustomerShortCode: string; CustomerName: string }) {
    const body = {
      criteria: {
        CustomerShortCode: customerData.CustomerShortCode,
        CustomerName: customerData.CustomerName,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/AddCustomer`, body);
  }

  setCustomerLicenses(payload: {
    CustomerShortCode: string;
    totalLicenses: number;
    licenseMode: 'POOL' | 'ASSIGNED';
  }) {
    const body = { criteria: { ...payload, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/SetCustomerLicenses`, body);
  }

  getCustomerLicenseSummary(customerShortCode: string) {
    const body = { criteria: { CustomerShortCode: customerShortCode, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/GetCustomerLicenseSummary`, body);
  }

  uploadCustomerBrandingAsset(payload: {
    CustomerShortCode: string;
    assetType: 'background' | 'logo';
    fileName: string;
    fileBase64: string;
  }) {
    const body = { criteria: { ...payload, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/UploadCustomerBrandingAsset`, body);
  }

  setCustomerSlideTypes(payload: {
    CustomerShortCode: string;
    slideTypeShortcodes: string[];
  }) {
    const body = { criteria: { ...payload, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/SetCustomerSlideTypes`, body);
  }

  setCustomerPptLayout(payload: {
    CustomerShortCode: string;
    pptLayoutName: string | null;
    pptLayoutWidthCm: number | null;
    pptLayoutHeightCm: number | null;
    pptSlideMasterName: string | null;
  }) {
    const body = { criteria: { ...payload, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/SetCustomerPptLayout`, body);
  }

  updateProjectStatus(projectData: any) {
    console.log("In the service - update status");
    console.log(`${this.apiUrl}/changeProjectStatus`);
    console.log(projectData);
    // const { ProjectShortCode, ProjectStatus, tenant = null } = req.body.criteria;

 const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let body = {
          "criteria": {
             "ProjectShortCode" : projectData.ProjectShortCode,
             "ProjectStatus": projectData.ProjectStatus,
                           tenant : null
                }
        };


    return this.commonAPI.postApiCall(`${this.apiUrl}/changeProjectStatus`, body);
   


   // return this.commonAPI.postApiCall(`${this.apiUrl}/changeProjectStatus`, projectData);

    // return this.http.post(`${this.apiUrl}/changeProjectStatus`, projectData);
  }

  /** Lessons available for creating a PPT project (may already be linked to other projects). */
  lessonsAvailableForPptProject() {
    const body = { criteria: { tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/lessonsAvailableForPptProject`, body);
  }

  /** Create project + projectparameters + project_lesson link in one step. */
  createProjectForLesson(payload: {
    ProjectShortCode: string;
    ProjectName: string;
    CustomerShortCode: string;
    lessonUserId: number;
    lessonId: number;
    templateId: string;
    layoutIds: string[];
    projectDefaultLayoutSC?: string | null;
    customFields: { name: string; value: string }[];
  }) {
    const body = { criteria: { ...payload, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/createProjectForLesson`, body);
  }

  updateProjectCustomer(projectData: any) {
    console.log(`${this.apiUrl}/changePprojectCustomerCode`);
// ProjectShortCode, CustomerShortCode, tenant = null
// 
const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        let body = {
          "criteria": {
             "ProjectShortCode" : projectData.ProjectShortCode,
             "CustomerShortCode": projectData.CustomerShortCode,
                           tenant : null
                }
        };


    return this.commonAPI.postApiCall(`${this.apiUrl}/changePprojectCustomerCode`, body);
   

    // return this.http.post(`${this.apiUrl}/changePprojectCustomerCode`, projectData);
  }

  changeProjectLifecycle(ProjectShortCode: string, projectLifecycleStatus: string) {
    const body = {
      criteria: {
        ProjectShortCode,
        projectLifecycleStatus,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/changeProjectLifecycle`, body);
  }

  // Other update methods...
}

